module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4zNyIgaGVpZ2h0PSI5LjAxOCIgdmlld0JveD0iMCAwIDE1LjM3IDkuMDE4Ij4NCiAgPHBhdGggaWQ9ImFycm93LWRvd24iIGQ9Ik0yNDAzLjMyMSwzOTkuMzE4Yy4yMTUuMDc4LDYsNiw2LDZsNi02IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQwMS43MTkgLTM5Ny41NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2JhYzNkNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIuNSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-down.svg
// module id = vjZZ
// module chunks = 3